import { useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import GlassCard from "../components/GlassCard";
import Reveal from "../components/Reveal";
import TiltCard from "../components/TiltCard";

import zohoImg from "../assets/zoho-session.jpg";
import alumniImg from "../assets/alumni-session.jpeg";
import hackathonImg from "../assets/hackathon.jpeg";
import tutorImg from "../assets/tutor.jpeg";
import tutorimg from "../assets/tutor.jpg";

import lectureVideo from "../assets/ngp-lecture.mp4";

const sessions = [
  {
    title: "Guest Lecturer – C Programming",
    org: "Dr. N.G.P Institute of Technology",
    desc: "Delivered a 3-hour interactive session covering C programming basics to intermediate concepts with quizzes.",
    video: lectureVideo,
    type: "video",
  },
  {
    title: "Zoho Round 1 Preparation Session",
    org: "Codex",
    desc: "Conducted session explaining Zoho round 1 preparation strategies.",
    image: zohoImg,
    type: "image",
  },
  {
    title: "Alumni Career Guidance",
    org: "SNS College of Technology",
    desc: "Mentored students on career paths in Cloud and Cybersecurity.",
    image: alumniImg,
    type: "image",
  },
  {
    title: "Cybersecurity Hackathon Jury",
    org: "SNS College of Technology",
    desc: "Evaluated innovative cybersecurity solutions.",
    image: hackathonImg,
    type: "image",
  },
  {
    title: "Part-time Tutor (3 Years)",
    org: "Murugan Tuition Center",
    desc: "Taught Computer Science and Chemistry for Classes 6–12.",
    images: [tutorImg, tutorimg],
    type: "double-image",
  },
];

const AutoPlayVideo = ({ item, setModalItem }) => {
  const videoRef = useRef(null);

  const handleLoaded = () => {
    if (videoRef.current) {
      videoRef.current.volume = 0.15;
    }
  };

  return (
    <div className="relative group cursor-pointer" onClick={() => setModalItem(item)}>
      
      <span className="absolute top-3 left-3 z-10 bg-cyan-500/20 text-cyan-300 text-xs px-3 py-1 rounded-full backdrop-blur border border-cyan-500/30">
        🎤 Guest Lecture
      </span>

      <motion.video
        ref={videoRef}
        className="w-full h-[240px] object-cover rounded-lg border border-white/30 shadow-lg"
        autoPlay
        loop
        muted
        playsInline
        onLoadedMetadata={handleLoaded}
      >
        <source src={item.video} type="video/mp4" />
      </motion.video>

    </div>
  );
};

const Instructor = () => {
  const [modalItem, setModalItem] = useState(null);

  return (
    <div className="max-w-7xl mx-auto px-6 py-16">

      <motion.h2
        className="text-4xl font-extrabold mb-12 text-center bg-gradient-to-r from-cyan-400 to-blue-600 text-transparent bg-clip-text"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
      >
        Instructor & Mentorship
      </motion.h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-10">

        {sessions.map((item, idx) => (
          <Reveal key={idx}>
            <TiltCard>

              <GlassCard className="backdrop-blur-xl bg-white/5 border border-white/20 p-6 rounded-2xl flex flex-col gap-4">

                {item.type === "image" && (
                  <img
                    src={item.image}
                    className="h-[240px] w-full object-cover rounded-lg cursor-pointer"
                    onClick={() => setModalItem(item)}
                  />
                )}

                {item.type === "double-image" && (
                  <div
                    className="grid grid-cols-2 gap-1 cursor-pointer relative"
                    onClick={() => setModalItem(item)}
                  >
                    <span className="absolute top-3 left-3 bg-purple-500/20 text-purple-300 text-xs px-3 py-1 rounded-full">
                      👨‍🏫 Teaching
                    </span>

                    <img src={item.images[0]} className="h-[240px] object-cover"/>
                    <img src={item.images[1]} className="h-[240px] object-cover"/>
                  </div>
                )}

                {item.type === "video" && (
                  <AutoPlayVideo item={item} setModalItem={setModalItem}/>
                )}

                <h3 className="text-xl font-bold text-cyan-400">{item.title}</h3>
                <p className="text-gray-400 text-sm">{item.org}</p>
                <p className="text-gray-300">{item.desc}</p>

              </GlassCard>

            </TiltCard>
          </Reveal>
        ))}

      </div>

      <AnimatePresence>
      {modalItem && (
        <motion.div
          className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 overflow-y-auto"
          onClick={() => setModalItem(null)}
        >
          <motion.div
            initial={{ scale: 0.85, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.85, opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="relative p-4 max-w-5xl w-full flex justify-center"
            onClick={(e) => e.stopPropagation()}
          >

            {/* Close Button */}
            <button
              onClick={() => setModalItem(null)}
              className="absolute top-2 right-2 bg-white/10 hover:bg-white/20 text-white backdrop-blur-md rounded-full w-10 h-10 flex items-center justify-center text-lg"
            >
              ✕
            </button>

            {modalItem.type === "video" && (
              <video
                controls
                autoPlay
                className="max-h-[80vh] rounded-xl"
              >
                <source src={modalItem.video} type="video/mp4" />
              </video>
            )}

            {modalItem.type === "image" && (
              <img
                src={modalItem.image}
                className="max-h-[80vh] rounded-xl object-contain"
              />
            )}

            {modalItem.type === "double-image" && (
              <div className="grid grid-cols-2 gap-3">
                <img
                  src={modalItem.images[0]}
                  className="rounded-xl max-h-[80vh] object-contain"
                />
                <img
                  src={modalItem.images[1]}
                  className="rounded-xl max-h-[80vh] object-contain"
                />
              </div>
            )}

          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>

    </div>
  );
};

export default Instructor;